import React from 'react';
import { checkSetState, changeState } from '@teammo/teammo-general-utils';
import classnames from 'classnames';
import _ from 'lodash';
import { parseAmount } from 'app/utils/parsers';
import {
  ITeamsSelector,
  IOrganisationsSelector,
  IGroupsSelector,
  IOrganisationSectionsSelector,
  IClubsSelector,
  ITeamMembersSelector,
} from 'app/types/selector';
import history from 'app/routes/history';
import { Form } from 'reactstrap';
import HeaderThin from 'app/components/layout/HeaderThin';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';

import ManageTeamMembers from 'app/features/manage-team/components/ManageTeamMembers';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as teamsActions from 'app/ducks/teams/actions';
import * as teamSelectors from 'app/ducks/teams/selectors';
import * as clubSelectors from 'app/ducks/clubs/selectors';
import * as teamMemberActions from 'app/ducks/teamMembers/actions';
import * as teamMemberSelectors from 'app/ducks/teamMembers/selectors';

import validateInput from './EditTeamValidator';

const selector = (state) => ({
  teams: teamSelectors.getTeams(state),
  clubs: clubSelectors.getClubs(state),
  teamMembers: teamMemberSelectors.getTeamMembers(state),
  isLoading: state.teams.isLoading,
  errors: state.teams.backendErrors,
});

const actionCreators = _.merge(teamsActions, teamMemberActions);

interface IEditTeamProps {
  organisations?: IOrganisationsSelector;
  teamMembers?: ITeamMembersSelector;
  teams?: ITeamsSelector;
  groups?: IGroupsSelector;
  clubs?: IClubsSelector;
  organisationSections?: IOrganisationSectionsSelector;
  name: string;
  teamId: string;
  isLoading?: boolean;
  appReady?: boolean;
  actions: any;
  match: any;
  errors?: any;
}

interface IEditTeamState {
  name: string;
  errors: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class EditTeam extends React.Component<
  IEditTeamProps,
  IEditTeamState
> {
  static defaultProps = {
    organisations: {},
    teams: {},
    clubs: {},
    groups: {},
    organisationSections: {},
    name: '',
    teamId: '',
    isLoading: false,
    appReady: false,
    actions: undefined,
    match: undefined,
    errors: {},
  };

  readonly state: IEditTeamState = {
    name: this.props.name || '',
    errors: {},
  };

  componentDidMount(): void {
    this.props.actions.getTeam(this.props.match.params.teamId);
    this.props.actions.getAllTeamMembers(
      {
        filter: { 'team-id': this.props.teams.currentTeamId },
      },
      false,
    );
  }

  UNSAFE_componentWillReceiveProps = (newProps): void => {
    this.setState(checkSetState(this.props, newProps));
  };

  handleChange = (e): void => {
    e.persist();
    this.setState((previousState) => changeState(previousState, e.target));
  };

  handleSubmit = (e): void => {
    e.preventDefault();

    if (this.isValid()) {
      this.props.actions.updateTeam({
        id: this.props.teamId,
        name: this.state.name,
      });
    }
  };

  isValid = (): boolean => {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  };

  handleCancel = (e): void => {
    e.preventDefault();
    if (
      this.props.teams !== undefined
      && this.props.teams.teamIds.length === 0
    ) {
      history.push('/teams');
    } else {
      history.push('/dashboard');
    }
  };

  renderForfeitFees = () => {
    if (
      _.isEmpty(this.props.teams.currentTeam.group.competition.walkoverFees)
    ) {
      return null;
    }
    const walkoverFees = _.sortBy(
      this.props.teams.currentTeam.group.competition.walkoverFees,
      'timeframe',
    );
    return _.map(walkoverFees, (fee) => {
      const feeName = fee.timeframe === null
        ? fee.name
        : `${fee.name} (Less than ${fee.timeframe} hours)`;

      return (
        <div className="row">
          <div className="col col-6 form-description text-weight-medium-bold">
            {feeName}
          </div>
          <div className="col col-6 form-description">
            {parseAmount(fee.amount)}
          </div>
        </div>
      );
    });
  };

  renderChange = (): React.ReactNode => {
    let tagList = _.map(
      this.props.teams.currentTeam.group.tagList,
      (tag) => `${tag.name}`,
    ).join(', ');

    tagList = tagList.substring(0, tagList.length);

    // let message;
    // if (
    //   _.isEmpty(this.props.teams.currentTeam.group.competition)
    //   || this.props.teams.currentTeam.group.competition.name === 'default'
    // ) {
    //   message = `Currently connected to association ${this.props.teams.currentTeam.organisation.name} in ${tagList}`;
    // } else {
    //   message = `Currently connected to association ${this.props.teams.currentTeam.organisation.name} in ${this.props.teams.currentTeam.group.competition.name} (${tagList})`;
    // }

    return (
      <div>
        <div className="row">
          <div className="col col-6 form-description text-weight-medium-bold">
            Association
          </div>
          <div className="col col-6 form-description">
            {this.props.teams.currentTeam.organisation.name}
          </div>
        </div>
        {!_.isEmpty(this.props.teams.currentTeam.group.competition) && (
          <div className="row">
            <div className="col col-6 form-description text-weight-medium-bold">
              Competition
            </div>
            <div className="col col-6 form-description">
              {this.props.teams.currentTeam.group.competition.name}
            </div>
          </div>
        )}
        <div className="row">
          <div className="col col-6 form-description text-weight-medium-bold">
            Section
          </div>
          <div className="col col-6 form-description">{tagList}</div>
        </div>
        <div className="row">
          <div className="col col-6 form-description text-weight-medium-bold">
            Team
          </div>
          <div className="col col-6 form-description">
            {this.props.teams.currentTeam.group.name}
          </div>
        </div>
        {!_.isEmpty(this.props.teams.currentTeam.group.competition)
          && this.renderForfeitFees()}
        <div className="row with-margin-top-10">
          <div className="col">
            <Button
              className="btn-2"
              onClick={() => history.push('/connect-team')}
            >
              Change Association Connection
            </Button>
          </div>
        </div>
      </div>
    );
  };

  renderAdd = (): React.ReactNode => (
    <div>
      <div className="row">
        <div className="col form-description">
          Not currently connected to an association or league
        </div>
      </div>
      <div className="row with-margin-top-10">
        <div className="col">
          <Button
            className="btn-success"
            onClick={() => history.push('/connect-team')}
          >
            Connect team
          </Button>
        </div>
      </div>
    </div>
  );

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin title={`Editing team ${this.props.name}`} divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col">
                <SectionGroup title="Team details">
                  <Form>
                    <div className="row">
                      <div className="col col-12">
                        <InputGroupBlock
                          name="name"
                          labelText="Team Name"
                          placeholder="Team name"
                          errors={this.props.errors}
                          value={this.state.name}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div
                      className={classnames('row', {
                        'd-none': this.state.name === this.props.name,
                      })}
                    >
                      <div className="col btn-flex-group less-padding">
                        <div className="btn-flex-container">
                          <Button
                            className="btn-success"
                            isLoading={this.props.isLoading}
                            onClick={this.handleSubmit}
                          >
                            Edit Team
                          </Button>
                          <Button
                            className="btn-2"
                            onClick={this.handleCancel}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </SectionGroup>
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col">
                <ManageTeamMembers
                  actions={this.props.actions}
                  isLoading={this.props.teamMembers.isLoading}
                  currentTeam={this.props.teams.currentTeam}
                  currentClub={this.props.clubs.currentClub}
                  errors={this.props.teamMembers.backendErrors}
                  teamMembersById={this.props.teamMembers.teamMembersById}
                  teamMemberIds={this.props.teams.currentTeam.teamMembers}
                />
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col">
                <SectionGroup title="Association connection">
                  {!this.props.teams.currentTeam.connectedToAssociation
                    && this.renderAdd()}
                  {this.props.teams.currentTeam.connectedToAssociation
                    && this.renderChange()}
                </SectionGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
